const commonLengthOptions = ['15', '30', '45', '60', '75', '90', '120'];

export const minLengthOptions = ['1', ...commonLengthOptions];

export const maxLengthOptions = [...commonLengthOptions, 'Unlimited'];
